export default __webpack_public_path__ + "static/media/settings.406cb837.svg";